import React, { useState, useEffect } from 'react';
import { isMobile } from '../../utilities/FrontFunctions/AoxGlobalFrontFunctions';
import { Link, useHistory } from 'react-router-dom';
// import { useNavigate } from 'react-router';

function ObjHeaderSearch(props){

	const [value, setValue] = useState('');
	const [visible, setVisible] = useState(true);
	const history = useHistory();
	
	useEffect(() => {
		setVisible(props.visible);
	}, [props.visible]);

	const handleClose = () => {
		setVisible(false);
		props.onClose();
	}
	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && value) {
			history.push(`${props.pageRecherche?.url}?search=${value}`);
		}
	};

	const { pageRecherche} = props;
	return(
		<>
		{visible &&
			<div className="obj_header-search">
				<div className="obj_form">
					<label className="t_label" htmlFor="header-search">Rechercher</label>
					<div className="ctn_input">
						<input
							type="text"
							id="header-search"
							name="header_search"
							onChange={(e) => {
								setValue(e.target.value);
							}}
							onKeyDown={handleKeyDown}
							value={value}
						/>
						{!value &&
							<button className="bt_reset-search" type="button" onClick={() => setValue('')}></button>
						}
						{isMobile() &&
							<button className="bt_close-search" type="button" onClick={() => handleClose()}>Annuler</button>
						}
					</div>
					<Link to={`${pageRecherche?.url}?search=${value}`}>
						<button className="obj_cta" type="submit" disabled={!value} >Valider</button>
					</Link>

				</div>
			</div>
		}
		</>
	)
}

export default ObjHeaderSearch;